import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesStickyBonusWPView} from "./BonusBunniesStickyBonusWPView";
import {IBonusSymbolQueue} from "../../server/data/IBonusSymbolQueue";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {TimelineLite} from "gsap";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-09-02.
 */

export class BonusBunniesStickyBonusWPController extends WinPresentationController {

    private _bonusValuesBeforeSpin:number[][];
    private _bonusValuesAfterSpin:number[][];
    private _bonusValuesLanding:number[][];
    private _bonusPositionsBeforeSpin:boolean[][];
    private _bonusPositionsAfterSpin:boolean[][];
    private _bonusSymbolQueue:IBonusSymbolQueue[];
    private _view:BonusBunniesStickyBonusWPView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusBunniesStickyBonusWPController", skippable : true});
        this._view = BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView = new BonusBunniesStickyBonusWPView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._bonusValuesLanding = data.bonusValuesBeforeSpin;
        if(data.mode == BonusBunniesGameMode.BONUS_GAME || data.nextMode == BonusBunniesGameMode.BONUS_GAME) {
            if((data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false) {
                //If a restore into Bonus game intro, the intro should trigger symbol change while it's black
                if(data.mode == BonusBunniesGameMode.NORMAL && data.nextMode == BonusBunniesGameMode.BONUS_GAME) {
                    this._view.activateRestoreMode(data.bonusOverlaySymbols, data.bonusPositionsBeforeSpin, data.bonusValuesBeforeSpin, false);
                } else {
                    this._view.activateRestoreMode(data.bonusOverlaySymbols, data.bonusPositionsBeforeSpin, data.bonusValuesBeforeSpin, true);
                }
            }
        }
    }

    //Used on Bonus Game start to set correct syms on reels
    public setStickyBonusSyms():void {
        this._view.setBonusIntroStickyBonusSyms(this._bonusValuesAfterSpin);
    }

    public abortMultiplierSymbols():void {
        this._view.abortMultiplierSymbols(this._bonusValuesAfterSpin);
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._bonusValuesBeforeSpin = data.bonusValuesBeforeSpin;
        this._bonusValuesAfterSpin = data.bonusValuesAfterSpin;
        this._bonusValuesLanding = data.bonusValuesLanding;
        this._bonusPositionsBeforeSpin = data.bonusPositionsBeforeSpin;
        this._bonusPositionsAfterSpin = data.bonusPositionsAfterSpin;
        this._bonusSymbolQueue = data.bonusSymbolQueue;
    }

    protected hasWin():boolean {
        return true;
    }

    public setStickyBonus(reel:number, row:number):TimelineLite {
        return this._view.setSingleStickyBonus(reel, row, this._bonusValuesLanding[reel][row]);
    }

    protected startWinPresentation():void {
        if(this._gameData!.nextMode == BonusBunniesGameMode.BONUS_GAME) {
            if(this._gameData!.mode == BonusBunniesGameMode.NORMAL) {
                this._view.setStickyBonus(this._bonusPositionsAfterSpin, this._bonusValuesLanding, false);
            } else {
                //(<BonusBunniesStickyBonusWPView>this._clickerView).setStickyBonus(this._bonusPositionsAfterSpin, this._bonusValuesAfterSpin);
            }
        }
        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}